
<template>
  <div class="overlay">
    <div class="overlay__inner">
      <div class="panel">
        <div class="panel__header">
          <h3 class="panel__title">Edit Metafields</h3>

          <span class="overlay__close" @click="done">
                        <i class="fal fa-times"></i>
                    </span>
        </div>

        <div class="panel__content">
          <div style="margin-bottom: 2rem;">
            <div class="form-field">
              <div class="grid-x grid-padding-x">
                <div class="cell small-4">
                  <label>Key</label>
                </div>
                <div class="cell small-5">
                  <label>Value</label>
                </div>
                <div class="cell shrink">

                </div>
              </div>
            </div>

            <div class="form-field" v-for="(metafield, i) in metafields" :key="i">
              <div class="grid-x grid-padding-x align-middle">
                <div class="cell small-4">
                  <input type="text" name="key" :value="metafield.key" v-on:input="metafield.key = $event.target.value">
                </div>
                <div class="cell small-5">
                  <input type="text" name="value" :value="metafield.value" v-on:input="metafield.value = $event.target.value">
                </div>
                <div class="cell shrink">
                                    <span @click="removeMetafield(i)" class="remove">
                                        <i class="fa fa-times"/>
                                    </span>
                </div>
              </div>
            </div>
          </div>

          <button class="button--alt" @click="addMetafield">
            <i class="fa fa-plus"></i>
            Add Metafield
          </button>

          <div class="panel__footer text-right">
            <button class="button--alt" @click="done">Cancel</button>
            <button @click="saveMetafields">Save</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import client from '@/mixins/client'
import utils from '@/mixins/utils'
import Checkbox from '@/globals/checkbox'

export default {
  components: {Checkbox},
  props: [
    'vendorId'
  ],
  mixins: [client, utils],
  data: function () {
    return {
      metafields: []
    }
  },
  methods: {
    done () {
      this.$emit('done')
    },
    addMetafield () {
      this.metafields.push({
        id: '',
        key: '',
        value: ''
      })
    },
    removeMetafield (index) {
      this.metafields.splice(index, 1)
    },
    saveMetafields () {
      this.request('post', '/vendors/' + this.vendorId + '/metafields/', {
        metafields: this.metafields
      }).then(response => {
        this.$emit('save')
      })
    }
  },
  created () {
    this.request('get', '/vendors/' + this.vendorId + '/metafields/'
    ).then(response => {
      for (let i = 0; i < response.length; i++) {
        this.metafields.push({
          id: response[i].id,
          key: response[i].key,
          value: response[i].value
        })
      }
    })
  }

}

</script>

<style lang="scss" scoped>
@import "../styles/mixins";
@import "../styles/variables";

.remove {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/globals/editMetafields.vue